import React from "react";

import { SvgIconComponent } from "@material-ui/icons";

import { LadderImageProps } from "./types";

const LadderImage: SvgIconComponent = (props: LadderImageProps) => (
  <svg
    width="311"
    height="171"
    viewBox="0 0 311 171"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M155.5 15.4771V170.34L0.637695 92.8629L155.5 15.4771Z"
        fill="#0049A7"
      />
      <path
        d="M155.5 15.4771V170.34L310.363 92.8629L155.5 15.4771Z"
        fill="#0D73D9"
      />
      <path
        d="M159.415 168.246L155.5 170.34L137.019 161.054L109.342 4.18799L132.558 15.7503L159.415 168.246Z"
        fill="#F09C9A"
      />
      <path
        d="M159.415 168.246L167.154 164.422L140.205 11.8354L132.558 15.7503L159.415 168.246Z"
        fill="#EE6D6A"
      />
      <path
        d="M132.558 15.7501L109.342 4.18776L117.08 0.272949L140.205 11.8353L132.558 15.7501Z"
        fill="#F2C4C3"
      />
      <path
        d="M73.2888 129.189L50.0731 117.627L36.5078 40.605L59.7236 52.1673L73.2888 129.189Z"
        fill="#F09C9A"
      />
      <path
        d="M82.4842 133.741L67.3712 48.2524L59.7236 52.1673L73.2889 129.189L82.4842 133.741Z"
        fill="#EE6D6A"
      />
      <path
        d="M59.7236 52.1671L36.5078 40.6048L44.2464 36.6899L67.3711 48.2523L59.7236 52.1671Z"
        fill="#F2C4C3"
      />
      <path
        d="M130.19 41.1511L71.3772 70.5577L70.2847 64.5489L123.544 37.8735L130.19 41.1511Z"
        fill="#F2C4C3"
      />
      <path
        d="M130.191 47.888L72.3789 76.7484L71.3774 70.5575L130.191 41.1509V47.888Z"
        fill="#EE6D6A"
      />
      <path
        d="M135.47 71.1037L76.5661 100.51L75.4736 94.4105L128.733 67.8262L135.47 71.1037Z"
        fill="#F2C4C3"
      />
      <path
        d="M135.471 77.7501L77.6594 106.61L76.5669 100.511L135.471 71.104V77.7501Z"
        fill="#EE6D6A"
      />
      <path
        d="M140.66 100.966L81.8469 130.373L80.7544 124.273L134.014 97.6885L140.66 100.966Z"
        fill="#F2C4C3"
      />
      <path
        d="M140.661 107.703L85.4893 135.289L82.3939 133.741L81.8477 130.372L140.661 100.966V107.703Z"
        fill="#EE6D6A"
      />
      <path
        d="M145.941 130.827L111.253 148.216L104.607 144.848L139.294 127.55L145.941 130.827Z"
        fill="#F2C4C3"
      />
      <path
        d="M145.94 137.565L117.99 151.495L111.253 148.217L145.94 130.828V137.565Z"
        fill="#EE6D6A"
      />
      <path
        d="M151.13 160.781L143.755 164.422L137.109 161.145L144.484 157.412L151.13 160.781Z"
        fill="#F2C4C3"
      />
      <path
        d="M151.13 167.426L150.493 167.791L143.756 164.422L151.13 160.78V167.426Z"
        fill="#EE6D6A"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="311" height="170.795" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LadderImage;
